export const PRIMARY_KEY_BY_OP_PATH = {
  'MECANIZAR.EXT': 'D1',
  'MECANIZAR.Pasante_INT': 'D1',
  'MECANIZAR.Ciego_INT': 'D1',
  'TALADRO.Agujeros': 'Diametro',
  'CHAVETERO.Chaveteros': 'Ancho',
  'TALLADO.Engranajes': 'M',
  'MECANIZAR_2FASE.EXT': 'D1',
  'MECANIZAR_2FASE.INT': 'D1',
};

function getOrCreateArray(om, opPath) {
  const keys = opPath.split('.');
  let cur = om;
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i];
    if (i === keys.length - 1) {
      if (!Array.isArray(cur[k])) cur[k] = [];
      return cur[k];
    }
    if (!cur[k] || typeof cur[k] !== 'object' || Array.isArray(cur[k])) cur[k] = {};
    cur = cur[k];
  }
  return [];
}

function getOrCreateObject(om, opPath) {
  const keys = opPath.split('.');
  let cur = om;
  for (const k of keys) {
    if (!cur[k] || typeof cur[k] !== 'object' || Array.isArray(cur[k])) cur[k] = {};
    cur = cur[k];
  }
  return cur;
}

function normalizeOverrides(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.filter((o) => o && o.op_path);
  if (typeof raw === 'object' && raw.op_path) return [raw];
  return [];
}

export function applyOverridesToOM(om, detections) {
  if (!om || typeof om !== 'object') return om;
  if (!Array.isArray(detections) || detections.length === 0) return om;
  const cloned = JSON.parse(JSON.stringify(om));
  detections.forEach((det) => {
    const overrideExtra = (det?.extras || []).find((e) => e?.label === '_match_override');
    if (!overrideExtra) return;
    const overrides = normalizeOverrides(overrideExtra.value);
    overrides.forEach((ov) => {
      if (!ov.fields || typeof ov.fields !== 'object') return;
      const opPath = ov.op_path;
      const fields = ov.fields;
      const isArray = opPath in PRIMARY_KEY_BY_OP_PATH;
      if (isArray) {
        const arr = getOrCreateArray(cloned, opPath);
        const targetOpPath = ov.target_op_path ?? null;
        const targetIdx = typeof ov.target_instance_idx === 'number' ? ov.target_instance_idx : null;
        let actualIdx = null;
        if (targetOpPath === opPath && targetIdx !== null && targetIdx >= 0 && targetIdx < arr.length) {
          actualIdx = targetIdx;
        } else {
          const pk = PRIMARY_KEY_BY_OP_PATH[opPath];
          const pkVal = fields[pk];
          if (pkVal !== undefined) {
            const found = arr.findIndex((it) => it && it[pk] === pkVal);
            if (found !== -1) actualIdx = found;
          }
        }
        if (actualIdx === null) {
          arr.push({ ...fields });
        } else {
          arr[actualIdx] = { ...arr[actualIdx], ...fields };
        }
      } else {
        const obj = getOrCreateObject(cloned, opPath);
        Object.assign(obj, fields);
      }
    });
  });
  return cloned;
}
